import React from 'react';
const rows: {
  problem: string;
  cost: string;
}[] = [{
  problem: 'Cotizar «lo que crees que van a aceptar»',
  cost: '$500–$2.000 que dejas sobre la mesa en cada boda'
}, {
  problem: 'Decir que sí al precio de amiga',
  cost: 'Una boda entera de trabajo que financias tú'
}, {
  problem: 'Presupuestos en visto, sin protocolo de seguimiento',
  cost: '7 de cada 10 consultas que se pierden sin saber por qué'
}, {
  problem: 'Cuota mensual a un directorio para competir por precio',
  cost: 'Cientos de dólares al año para atraer justo a quien regatea'
}, {
  problem: 'Cerrar de palabra, sin contrato ni anticipo',
  cost: 'Una sola cancelación y pierdes meses de trabajo'
}, {
  problem: 'Cada boda termina y no pasa nada más',
  cost: 'Tres clientas que nunca supiste que podías tener'
}];
export function CostOfInaction() {
  return <section className="w-full bg-ivory py-16 sm:py-24" data-id="element-78" data-mp="3sl2upokm1xxg">
      <div className="mx-auto max-w-4xl px-5" data-id="element-79" data-mp="3sji1q3dy2n1p">
        <h2 className="text-center font-serif text-3xl sm:text-5xl text-ink" data-id="element-80" data-mp="3egq19zcbg61d">
          ¿Cuánto te está costando seguir improvisando?
        </h2>
        <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-81" data-mp="39jg41xioqq2z" />

        <div className="mt-12 overflow-hidden border border-gold-soft bg-white" data-id="element-82" data-mp="34j1xyl0n9q7l">
          <div className="grid grid-cols-1 sm:grid-cols-2" data-id="element-83" data-mp="30hqekx8d617u">
            <div className="border-b border-gold-soft px-6 py-4 text-[11px] uppercase tracking-[0.2em] text-ink-muted sm:border-r" data-id="element-84" data-mp="11jyb0v0zpi9">
              Sin el sistema
            </div>
            <div className="hidden border-b border-gold-soft bg-blush-soft px-6 py-4 text-[11px] uppercase tracking-[0.2em] text-blush-deep sm:block" data-id="element-85" data-mp="3s9xsvr0ed1j2">
              El costo real
            </div>
          </div>

          {rows.map((row, index) => <div key={row.problem} className={`grid grid-cols-1 sm:grid-cols-2 ${index > 0 ? 'border-t border-gold-soft/70' : ''}`} data-id="element-86" data-mp="jsb823ixdhx6" data-mpi={index}>
              <p className="px-6 py-5 text-[15px] text-ink-soft sm:border-r sm:border-gold-soft/70" data-id="element-87" data-mp="29a81bwoyc83g">
                {row.problem}
              </p>
              <p className="bg-blush-soft/50 px-6 py-5 text-[15px] font-medium text-blush-deep" data-id="element-88" data-mp="2ea44jtptrvhy">
                {row.cost}
              </p>
            </div>)}
        </div>

        <p className="mt-12 text-center font-serif text-2xl italic sm:text-3xl text-ink" data-id="element-89" data-mp="24gdkr24n898l">
          Una sola boda bien cobrada paga este sistema 100 veces.
        </p>
        <p className="mt-4 text-center text-base text-gold-dark" data-id="element-90" data-mp="1vijpzvmj1nnj">
          Tu próximo &ldquo;Hola, ¿precio para boda?&rdquo; puede terminar completamente
          distinto.
        </p>
      </div>
    </section>;
}